import * as _ from 'lodash';
import ContentLoader from 'react-content-loader';
import { useSelector } from 'react-redux';
import type { RefObject, VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../../redux/packageInventory';
import VulnBadge from '../../../generic/VulnBadge';
import type { PackageVersionVulnerability } from '../../../../../shared/organizationPackages';

import styles from './VulnerabilitiesTable.module.less';

type VulnerabilitiesTableBodyProps = {
  vulnerabilities: PackageVersionVulnerability[];
  onVulnSelect: (vulnId: string) => void;
  //  This is to tell the Drawer not to close if we click the table again.
  //  Clicking a different vuln will still cause that vuln to be fetched.
  tableBodyRef: RefObject<HTMLTableSectionElement>;
};

const loadingRows = _.times(3, () => (
  <tr>
    <td colSpan={4}>
      <ContentLoader viewBox="0 0 100% 20" width="100%" height="20">
        <rect x="0" y="0" rx="3" ry="3" width="100%" height="20" />
      </ContentLoader>
    </td>
  </tr>
));

const VulnerabilitiesTableBody: VoidFunctionComponent<VulnerabilitiesTableBodyProps> = ({
  vulnerabilities,
  onVulnSelect,
  tableBodyRef,
}) => {
  const { isLoading } = useSelector(
    PackageInventoryStore.selectors.getAsyncStatusGetPackageVulnerabilities,
  );

  const rows = isLoading
    ? loadingRows
    : vulnerabilities.map((row) => {
      return (
        <tr
          key={row.vulnId}
          className={styles.tableRow}
          onClick={() => onVulnSelect(row.vulnId)}
        >
          <td className="severity-column">
            <VulnBadge cvss={row.cvss} />
          </td>
          <td>
            {row.title}
          </td>
          <td className="cve">{row.cve}</td>
          <td className="fixable">{row.fixable ? 'Has fix' : 'No fix'}</td>
        </tr>
      );
    });

  return <tbody ref={tableBodyRef}>{rows}</tbody>;
};

export default VulnerabilitiesTableBody;
